import {
  addObj,
  getAll,
  searchByName,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  getQiniuUploadToken,
} from '@/api/pictureserv'

export default {
  state: {
    state_Picture_AddObjResult: null,
    state_Picture_GetAllResult: null,
    state_Picture_SearchByNameResult: null,
    state_Picture_GetPageResult: null,
    state_Picture_GetDetailResult: null,
    state_Picture_ModifyObjResult: null,
    state_Picture_DeleteObjResult: null,
    state_Picture_GetQiniuUploadTokenResult: null,
  },
  mutations: {
    SET_PICTURE_ADDOBJ_RESULT: (state, rst) => {
      state.state_Picture_AddObjResult = rst;
    },
    SET_PICTURE_GETALL_RESULT: (state, rst) => {
      state.state_Picture_GetAllResult = rst;
    },
    SET_PICTURE_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_Picture_SearchByNameResult = rst;
    },
    SET_PICTURE_GETPAGE_RESULT: (state, rst) => {
      state.state_Picture_GetPageResult = rst;
    },
    SET_PICTURE_GETDETAIL_RESULT: (state, rst) => {
      state.state_Picture_GetDetailResult = rst;
    },
    SET_PICTURE_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_Picture_ModifyObjResult = rst;
    },
    SET_PICTURE_DELETEOBJ_RESULT: (state, rst) => {
      state.state_Picture_DeleteObjResult = rst;
    },
    SET_PICTURE_GETQINIUUPLOADTOKEN_RESULT: (state, rst) => {
      state.state_Picture_GetQiniuUploadTokenResult = rst;
    },
  },
  actions: {
    PictureServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PICTURE_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PICTURE_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PictureServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PICTURE_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PICTURE_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PictureServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PICTURE_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PICTURE_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PictureServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PICTURE_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PICTURE_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PictureServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PICTURE_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PICTURE_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PictureServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PICTURE_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PICTURE_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PictureServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PICTURE_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PICTURE_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PictureServ_GetQiniuUploadToken({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getQiniuUploadToken(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PICTURE_GETQINIUUPLOADTOKEN_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PICTURE_GETQINIUUPLOADTOKEN_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_Picture_AddObjResult: state => {
      return state.state_Picture_AddObjResult;
    },
    get_Picture_GetAllResult: state => {
      return state.state_Picture_GetAllResult;
    },
    get_Picture_SearchByNameResult: state => {
      return state.state_Picture_SearchByNameResult;
    },
    get_Picture_GetPageResult: state => {
      return state.state_Picture_GetPageResult;
    },
    get_Picture_GetDetailResult: state => {
      return state.state_Picture_GetDetailResult;
    },
    get_Picture_ModifyObjResult: state => {
      return state.state_Picture_ModifyObjResult;
    },
    get_Picture_DeleteObjResult: state => {
      return state.state_Picture_DeleteObjResult;
    },
    get_Picture_GetQiniuUploadTokenResult: state => {
      return state.state_Picture_GetQiniuUploadTokenResult;
    },
  }
}